/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Modal } from '@components/v2/Modal';
import { Button } from '@ui';
import TabView from '@components/TabView';
import { translate } from '@utils/i18n';
import ConfirmDialog from '@components/ConfirmDialog/ConfirmDialog';
import QuestionsTab from './tabs/QuestionsTab';
import ComponentTypesTab from './tabs/ComponentTypesTab';
import ConfigureTab from './tabs/ConfigureTab';
import './QuestionSetDetailModalStyles.scss';
const namespace = 'features.settings.component_questions';
export default function QuestionSetDetailModal({ isOpen, onClose, questionSet, onToggleActive, onUpdate, isTogglingActive = false }) {
    const [isActionConfirmOpen, setIsActionConfirmOpen] = useState(false);
    const handleAction = () => {
        if (questionSet) {
            setIsActionConfirmOpen(true);
        }
    };
    const handleConfirmAction = () => {
        if (questionSet) {
            void onToggleActive(questionSet.id);
        }
        setIsActionConfirmOpen(false);
    };
    const handleCancelAction = () => {
        setIsActionConfirmOpen(false);
    };
    if (!questionSet)
        return null;
    const modalTitle = (React.createElement("div", { className: "question-set-detail-modal__header" },
        React.createElement("div", { className: "question-set-detail-modal__header-content" },
            React.createElement("span", null,
                React.createElement("b", null,
                    translate('question_set_label', { namespace }),
                    ":"),
                " ",
                questionSet.name)),
        React.createElement(Button, { onClick: handleAction, disabled: isTogglingActive }, isTogglingActive ? (React.createElement("i", { className: "fa fa-spinner fa-spin" })) : (React.createElement(React.Fragment, null,
            React.createElement("i", { className: questionSet.active ? 'fa fa-ban' : 'fa fa-check-circle' }),
            ' ',
            questionSet.active
                ? translate('deactivate', { namespace: 'features.commons' })
                : translate('activate', { namespace: 'features.commons' }))))));
    const tabs = [
        {
            id: 'questions',
            label: translate('questions_tab', { namespace }),
            content: React.createElement(QuestionsTab, { questionSetId: questionSet.id })
        },
        {
            id: 'component-types',
            label: translate('component_types_tab', { namespace }),
            content: React.createElement(ComponentTypesTab, { questionSetId: questionSet.id })
        },
        {
            id: 'configure',
            label: translate('configure_tab', { namespace }),
            content: React.createElement(ConfigureTab, { questionSet: questionSet, onUpdate: onUpdate })
        }
    ];
    return (React.createElement(Modal, { title: modalTitle, isOpen: isOpen, onClose: onClose, width: "900px", className: "question-set-detail-modal" },
        React.createElement("div", { className: "question-set-detail-modal__content" },
            React.createElement(TabView, { tabs: tabs })),
        isActionConfirmOpen && (React.createElement(ConfirmDialog, { title: translate(questionSet.active ? 'deactivate_question_set_title' : 'activate_question_set_title', {
                namespace
            }), description: translate(questionSet.active ? 'deactivate_question_set_description' : 'activate_question_set_description', { namespace }), onConfirm: handleConfirmAction, onCancel: handleCancelAction, yesLabel: translate(questionSet.active ? 'deactivate' : 'activate', { namespace: 'features.commons' }), noLabel: translate('cancel', { namespace: 'features.commons' }) }))));
}
